import { ClosedEnvelopeIcon, PhoneIcon, WorldIcon } from "~/common/components";
import {
  getProviderSchedulingMethodByType,
  OrganizationTeamMember,
} from "~/common/utils";
import { formatPhoneNumber } from "~/patients/utils";
import {
  phoneNumberModes,
  PROVIDER_SCHEDULE_METHODS,
} from "~/providers/constants/teamMembers";
import { SchedulingMethod } from "./SchedulingMethod";

interface ProviderSchedulingMethodsProps {
  provider: OrganizationTeamMember;
}

export const ProviderSchedulingMethods = ({
  provider,
}: ProviderSchedulingMethodsProps) => {
  const phoneScheduleMethod = getProviderSchedulingMethodByType(
    PROVIDER_SCHEDULE_METHODS.PHONE,
    provider,
  );
  const emailScheduleMethod = getProviderSchedulingMethodByType(
    PROVIDER_SCHEDULE_METHODS.EMAIL,
    provider,
  );
  const calendarScheduleMethod = getProviderSchedulingMethodByType(
    PROVIDER_SCHEDULE_METHODS.CALENDAR,
    provider,
  );

  return (
    <div className="flex flex-col gap-3">
      {phoneScheduleMethod?.active && (
        <SchedulingMethod icon={<PhoneIcon />}>
          <p>
            Phone:{" "}
            <a
              href={`tel:${formatPhoneNumber(phoneScheduleMethod.data.number)}`}
              className="underline"
            >
              {formatPhoneNumber(phoneScheduleMethod.data.number)}
            </a>{" "}
            {phoneScheduleMethod.data.ext && (
              <span>ext. {phoneScheduleMethod.data.ext}</span>
            )}
          </p>
          <p>
            (
            {
              phoneNumberModes.find(
                (mode) => mode.value === phoneScheduleMethod.data.variant,
              )?.label
            }
            )
          </p>
        </SchedulingMethod>
      )}

      {emailScheduleMethod?.active && (
        <SchedulingMethod icon={<ClosedEnvelopeIcon />}>
          <p>
            Email:{" "}
            <a
              href={`mailto:${emailScheduleMethod.data.email}`}
              className="underline"
            >
              {emailScheduleMethod.data.email}
            </a>
          </p>
        </SchedulingMethod>
      )}

      {calendarScheduleMethod?.active && (
        <SchedulingMethod icon={<WorldIcon />}>
          <p>
            Online:{" "}
            <a
              href={calendarScheduleMethod.data.link}
              target="_blank"
              rel="noreferrer"
              className="underline"
            >
              {calendarScheduleMethod.data.link}
            </a>
          </p>
        </SchedulingMethod>
      )}
    </div>
  );
};
